import { Star, Quote } from "lucide-react";
import { COMPANY, REVIEWS } from "../lib/constants";

export default function Reviews() {
  return (
    <section
      data-testid="reviews-section"
      className="max-w-7xl mx-auto px-4 md:px-8 py-20 md:py-28"
    >
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 mb-12">
        <div className="lg:col-span-7">
          <div className="inline-flex items-center gap-2 text-xs font-bold uppercase tracking-widest text-teal-700 mb-3">
            <Star className="w-4 h-4 fill-amber-400 text-amber-400" /> Avis clients
          </div>
          <h2 className="font-display text-3xl md:text-5xl font-extrabold tracking-tight text-slate-900 leading-tight">
            Ce que disent
            <br />
            <span className="text-teal-600">nos clients sur Google.</span>
          </h2>
        </div>
        <div className="lg:col-span-5 flex items-end">
          <div className="rounded-3xl bg-white border border-slate-200 p-6 w-full">
            <div className="flex items-center justify-between gap-4">
              <div>
                <div className="flex items-center gap-1 mb-1">
                  {[...Array(5)].map((_, i) => (
                    <Star
                      key={i}
                      className="w-5 h-5 fill-amber-400 text-amber-400"
                    />
                  ))}
                </div>
                <div className="text-sm text-slate-600">
                  Note moyenne sur{" "}
                  <strong>{COMPANY.googleReviews} avis</strong>
                </div>
              </div>
              <div className="text-right">
                <div className="font-display text-4xl font-extrabold text-slate-900 leading-none">
                  {COMPANY.googleRating}
                  <span className="text-lg text-slate-400">/5</span>
                </div>
                <div className="text-[10px] uppercase tracking-widest text-slate-500 font-bold mt-1">
                  Note Google
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
        {REVIEWS.map((r, i) => (
          <article
            key={i}
            data-testid={`review-${i + 1}`}
            className={`group relative rounded-3xl border p-7 flex flex-col transition-all hover:-translate-y-0.5 hover:shadow-xl ${
              i === 0
                ? "bg-slate-900 text-white border-slate-900"
                : "bg-white text-slate-900 border-slate-200 hover:border-teal-500"
            }`}
          >
            <Quote
              className={`absolute top-5 right-5 w-8 h-8 ${
                i === 0 ? "text-teal-400/40" : "text-slate-200"
              }`}
            />
            <div className="flex items-center gap-1 mb-4">
              {[...Array(r.rating)].map((_, idx) => (
                <Star
                  key={idx}
                  className="w-4 h-4 fill-amber-400 text-amber-400"
                />
              ))}
            </div>
            <p
              className={`leading-relaxed mb-5 ${
                i === 0 ? "text-slate-100" : "text-slate-700"
              }`}
            >
              « {r.text} »
            </p>
            <div
              className={`mt-auto pt-4 border-t flex items-center justify-between gap-3 ${
                i === 0 ? "border-white/10" : "border-slate-100"
              }`}
            >
              <div>
                <div
                  className={`font-display font-extrabold ${
                    i === 0 ? "text-white" : "text-slate-900"
                  }`}
                >
                  {r.name}
                </div>
                <div
                  className={`text-xs ${
                    i === 0 ? "text-slate-400" : "text-slate-500"
                  }`}
                >
                  {[r.city, r.date].filter(Boolean).join(" · ")}
                </div>
              </div>
              {r.service && (
                <span
                  className={`text-[10px] font-bold uppercase tracking-widest px-2.5 py-1 rounded-full ${
                    i === 0
                      ? "bg-teal-500/20 text-teal-300 border border-teal-400/30"
                      : "bg-teal-50 text-teal-700"
                  }`}
                >
                  {r.service}
                </span>
              )}
            </div>
          </article>
        ))}
      </div>

      <p
        data-testid="reviews-disclaimer"
        className="text-xs text-slate-500 mt-6 italic"
      >
        Avis vérifiés issus de notre fiche Google Business Profile · Note
        moyenne mise à jour régulièrement.
      </p>
    </section>
  );
}
